import config from '../../config';
import cdnResizeUrl from '../services/cdnResizeUrl';
import _isCdnResizeEnabled from '../services/isCdnResizeEnabled';

const S3_PATTERN = /^https?:\/\/slinging(?:-staging)?\.s3(?:\.[^.]+)?\.amazonaws\.com\/(.+)/;

export default function avatar(AvatarErrorsService) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      user: '=',
    },
    template: `
      <div ng-style="style" class="avatar {{ ::addclass }}">
        <span ng-hide="avatar">{{ userInitials }}</span>
      </div>
    `,
    link(scope, element, attrs) {
      scope.size = attrs.size;

      function getRawUrl() {
        if (!scope.avatar) {
          return '';
        }
        return scope.avatar;
      }

      function applyAvatarStyle(url) {
        scope.avatarUrl = url;
      }

      // scope.avatarUrlSettled resolves once the style for the current avatar
      // has been decided — callers and tests can block on it. It is now always
      // synchronous (the flag is a config constant), but stays a resolved
      // Promise so existing awaiters keep working.
      function refreshAvatarUrl() {
        if (!scope.avatar) {
          applyAvatarStyle('');
          scope.avatarUrlSettled = Promise.resolve();
          return;
        }
        const m = scope.avatar.match(S3_PATTERN);
        if (!m) {
          applyAvatarStyle(scope.avatar);
          scope.avatarUrlSettled = Promise.resolve();
          return;
        }
        if (_isCdnResizeEnabled()) {
          applyAvatarStyle(cdnResizeUrl(scope.avatar, 256, 256, 'cover'));
        } else {
          applyAvatarStyle(
            `${config.CLOUDINARY_BASE_URL}image/fetch/h_256,w_256,c_thumb,g_face,z_0.7,r_max,f_auto/${encodeURIComponent(scope.avatar)}`
          );
        }
        scope.avatarUrlSettled = Promise.resolve();
      }

      Object.defineProperty(scope, 'style', {
        get() {
          return {
            width: `${scope.size}px`,
            height: `${scope.size}px`,
            'background-image': `url("${scope.avatarUrl || getRawUrl()}")`,
            'font-size': `${scope.size}px`,
          };
        },
      });

      scope.addclass = attrs.addclass;

      const image = new Image();
      image.onerror = () => {
        scope.$evalAsync(() => {
          AvatarErrorsService.addError(scope.avatar);
          scope.avatar = null;
        });
      };

      scope.$watch('user.avatar', (value) => {
        if (AvatarErrorsService.hasError(value) || !value) {
          scope.avatar = null;
        } else {
          scope.avatar = value;
        }

        refreshAvatarUrl();

        if (scope.avatar) {
          image.src = getRawUrl();
        }
      });

      scope.$watch('user.fullname', () => {
        const { name = '', lastname = '' } = scope.user;
        scope.userInitials = `${name[0] || ''}${lastname[0] || ''}`.toUpperCase();
      });
    },
  };
}
